import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type ValidateCosting = ClientInferResponseBody<
  typeof contract.quoteRequestLines.bulkValidateCosting
>;

export const validateCosting = async ({
  quoteRequestLineIds,
}: {
  quoteRequestLineIds: string[];
}): Promise<ValidateCosting> => {
  if (quoteRequestLineIds.length === 0) {
    throw new Error("Au moins un identifiant de ligne de demande de devis est requis");
  }

  const response = await api.quoteRequestLines.bulkValidateCosting.mutation({
    body: {
      quoteRequestLineIds,
    },
  });

  if (response.status === 404) {
    throw new ApiError(
      "Les lignes de demande de devis n'ont pas été trouvées",
      response.status,
      response.body,
    );
  }

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Une erreur est survenue lors de la validation des coûts",
    response.status,
    response.body,
  );
};
